import { TaskName } from '@/common/constants/taskNames.constants';
import { TaskState } from '@schema';
import i18n from '@/common/i18n';
import type { TaskMap } from '@/common/store/modules/tasks/tasksNotificationMapper';

const vhsMap: TaskMap = {
  [TaskName.VHS_DEPLOY]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('VHS compute deployed'),
      message: i18n.t('VHS compute successfully deployed'),
    }),
    [TaskState.RUNNING]: ({ progress = 0 }) => ({
      title: i18n.t('Deploying VHS compute...'),
      message: i18n.t('{0}% completed', [progress]),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error deploying VHS compute'),
      message: error,
    })
  },
};

export default vhsMap;
